import { formatDayLabel } from "../formatDay";

/**
 * "Grupe jela" na telefonu: kartica po danu sa brojem obroka po grupi jela i smeni (samo izabrane smene i grupe).
 * Zahteva nasleđen stari tab sa dateArray, mealCategories, selectedCategories, selectedShifts i categoryLabels, i
 * računato svojstvo `groupedDaily` ({ [datum]: { [`${grupa}_${smena}`]: količina } }) koje ekran daje.
 */
export default {
  computed: {
    formatLocale() {
      const config = this.getCurrentLanguageConfig();
      return config.script === "latin" && config.locale === "sr-RS" ? "sr-Latn-RS" : config.locale;
    },
    shownCategories() {
      return this.mealCategories.filter((category) => this.selectedCategories.includes(category));
    },
    /** Dani sa narudžbama: po grupi jela ukupno i po smeni. */
    days() {
      return this.dateArray
        .map((date) => {
          const daily = this.groupedDaily[date] || {};
          const rows = this.shownCategories
            .map((category) => {
              const shifts = [1, 2, 3, 4]
                .filter((shift) => this.selectedShifts.includes(shift))
                .map((shift) => ({ id: shift, quantity: daily[`${category}_${shift}`] || 0 }))
                .filter((shift) => shift.quantity > 0);
              return {
                key: `${date}-${category}`,
                name: this.categoryLabels[category],
                total: shifts.reduce((sum, shift) => sum + shift.quantity, 0),
                shifts,
              };
            })
            .filter((row) => row.total > 0);
          return {
            key: date,
            label: formatDayLabel(date, this.formatLocale),
            total: rows.reduce((sum, row) => sum + row.total, 0),
            rows,
          };
        })
        .filter((day) => day.rows.length);
    },
    mealTotal() {
      return this.days.reduce((sum, day) => sum + day.total, 0);
    },
  },
};
